export const USER_ROLES = {
  NO_ROLE: "",
  ADMIN_ROLE: "5737c5b7-958a-f011-b485-002248241529",
  MANAGER_ROLE: "b554ea4c-55ba-4355-8c88-dd7c9f058f6b",
  CONTENT_MANAGER: "bd405814-bee7-4de4-97c7-e0ff5d1618c8",
  SCHEDULE_MANAGER: "55ec3e61-a2aa-400c-9d68-9f0ad244f6a5",
};
